import { render, staticRenderFns } from "./roleEditor.pug?vue&type=template&id=224db06d&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./roleEditor.scss?vue&type=style&index=0&id=224db06d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224db06d",
  null
  
)

export default component.exports